module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-11.3e972831.png";